import React from 'react'
import { Helmet } from 'react-helmet'

const MetaDecorator = ({title, desc, imageUrl, url}) => {
  return (
    <Helmet>
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:url" content={url} />
    </Helmet>
  )
}

export default MetaDecorator
